module.exports = __webpack_public_path__ + "static/media/icon_tooltip.9934bb7f.svg";